import moment from "moment"
import {setLoading} from "../reducers/configSlice";
import { Store } from "../reducers/store"
import {sprintf} from "../services/helpers/translate";
import {apiDelete, apiPost, apiGet} from "./apiSlice";
import {
    API_REGISTER_DEVICE,
    API_CHECKIN_BOOKING,
    API_SAVE_BOOKING, API_UPDATE_BOOKING, API_AUTHORIZATION_TOKEN, API_CHECKIN_SPACE, API_DEVICE_CONFIG,
    API_DEVICE_BOOKING_LIST, API_DEVICE_MAINTENANCE
} from "../constants/apiConstants";
import {STORAGE} from "../services/storage";
import moment_tz from "moment-timezone";
import axios from "axios";
import {DEVICE_TYPE} from "../constants/default";
import { API_VERSION } from "../constants/versionConstants";

const errorFormatter = (response) => {
    if (response.error) {
        console.log('YAROOMS-MEETING-ROOM-DISPLAY: ERROR ' + JSON.stringify(response.error))
        if (response.error.status === 404) {
            return {
                error: "404 " + translate("Not Found")
            }
        } else {
            return response.error.data ? response.error.data : response.error
        }
    }
}

const axiosInstance = axios.create({
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'User-Agent': `YAROOMS-MEETING_ROOM_DISPLAY/${API_VERSION}`
    }
});

export const apiRegisterDevice = async (uuid, hash, companyId, ignoreLoading = false, extraParams = {}) => {
    Store.dispatch(setLoading(true))

    const requestData = {
        uuid: uuid,
        company_id: companyId,
        device_type: DEVICE_TYPE,
        ...extraParams
    };

    // Only include hash if it's provided (not null/undefined)
    if (hash !== null && hash !== undefined) {
        requestData.hash = hash;
    }

    let result = await Store.dispatch(apiPost(API_REGISTER_DEVICE, requestData))

    if (result.error) {
        Store.dispatch(setLoading(false))
        return errorFormatter(result)
    }

    if (!ignoreLoading) {
        Store.dispatch(setLoading(false))
    }

    return {
        response: result.data.data
    }
}

export const apiSaveBooking = async (data) => {
    Store.dispatch(setLoading(true))

    let result = await Store.dispatch(apiPost(API_SAVE_BOOKING, data))

    if (result.error) {
        Store.dispatch(setLoading(false))
        return errorFormatter(result)
    }

    if (result.data.data.status === 1 && Store.getState().data.config.has_checkin) {
        const timezone = Store.getState().data.config.timezone
        const currentMoment = moment().tz(timezone)

        const startMoment = moment_tz.tz(result.data.data.dates[0].start, timezone).utc().tz(timezone)
        const endMoment = moment_tz.tz(result.data.data.dates[0].end, timezone).utc().tz(timezone)

        if (currentMoment.isBetween(startMoment, endMoment)) {
            let checkinResult = await Store.dispatch(apiPost(sprintf(API_CHECKIN_BOOKING, [result.data.data.id])))

            if (checkinResult.error) {
                Store.dispatch(setLoading(false))
                return errorFormatter(checkinResult)
            }

            Store.dispatch(setLoading(false))
            return checkinResult.data.data
        }
    }

    Store.dispatch(setLoading(false))
    return result.data.data
}

export const apiUpdateBooking = async (id, data) => {
    Store.dispatch(setLoading(true))
    let result = await Store.dispatch(apiPost(sprintf(API_UPDATE_BOOKING, [id]), data))

    if (result.error) {
        Store.dispatch(setLoading(false))
        return errorFormatter(result)
    }

    Store.dispatch(setLoading(false))
    return result.data.data
}

export const apiDeleteBooking = async (id, data) => {
    Store.dispatch(setLoading(true))
    let result = await Store.dispatch(apiDelete(sprintf(API_UPDATE_BOOKING, [id])))

    if (result.error) {
        Store.dispatch(setLoading(false))
        return errorFormatter(result)
    }

    Store.dispatch(setLoading(false))
    return result.data
}

export const apiCheckinBooking = async (booking) => {
    Store.dispatch(setLoading(true))

    if (booking.early) {
        const now = moment().tz(Store.getState().data.config.timezone)
        const minutesToSubtract = now.minute() % Store.getState().data.config.granularity
        const newStart = now.subtract(minutesToSubtract, "minutes").format('YYYY-MM-DD HH:mm')

        let data = {}
        data["dates[0][start]"] = newStart
        data["dates[0][end]"] = booking.end

        if (booking.other_dates && booking.other_dates.length) {
            booking.other_dates.forEach( (date, index) => {
                data["dates[" + (index + 1) + "][start]"] = date.start
                data["dates[" + (index + 1) + "][end]"] = date.end
            })
        }

        let result = await Store.dispatch(apiPost(sprintf(API_UPDATE_BOOKING, [booking.booking_id]), data))
        if (result.error) {
            Store.dispatch(setLoading(false))
            return errorFormatter(result)
        }
    }

    let result = await Store.dispatch(apiPost(sprintf(API_CHECKIN_BOOKING, [booking.booking_id]), {space_id: booking.space_id}))

    if (result.error) {
        Store.dispatch(setLoading(false))
        return errorFormatter(result)
    }

    Store.dispatch(setLoading(false))
    return result.data.data
}

export const apiCheckinSpace = async (spaceId) => {
    Store.dispatch(setLoading(true))

    let result = await Store.dispatch(apiPost(sprintf(API_CHECKIN_SPACE, [spaceId])))

    if (result.error) {
        Store.dispatch(setLoading(false))
        return errorFormatter(result)
    }

    Store.dispatch(setLoading(false))
    return result.data.data
}

export const apiAuthorizationToken = async (action, params) => {
    Store.dispatch(setLoading(true))

    const data = {
        data: {
            action: action,
            device_id: Store.getState().data.config.device_id,
            params: params
        }
    }

    let result = await Store.dispatch(apiPost(API_AUTHORIZATION_TOKEN, data))

    if (result.error) {
        Store.dispatch(setLoading(false))
        return errorFormatter(result)
    }

    Store.dispatch(setLoading(false))

    if (result.data.data && result.data.data.includes('?code=')) {
        const code = result.data.data.slice(result.data.data.indexOf('?code=') + '?code='.length)
        result.data = {...result.data, code: code}
    }

    return result.data
}

export const apiGetDeviceConfig = async () => {
    Store.dispatch(setLoading(true))

    // Get device_id from Redux store first, then fallback to storage
    let deviceId = Store.getState().data.config.device_id;

    if (!deviceId) {
        // Try to get device_id from local storage
        deviceId = await STORAGE.get('deviceId');
    }

    if (!deviceId) {
        Store.dispatch(setLoading(false))
        return {
            error: "Device ID not found in configuration or storage"
        }
    }

    // Build URL with device_id parameter and version query parameter
    const endpoint = sprintf(API_DEVICE_CONFIG, [deviceId]);
    let result = await Store.dispatch(apiGet(endpoint, { v: API_VERSION }))

    if (result.error) {
        Store.dispatch(setLoading(false))
        return errorFormatter(result)
    }

    Store.dispatch(setLoading(false))
    return {
        response: result.data
    }
}

export const apiGetDeviceBookingList = async (date = null) => {
    Store.dispatch(setLoading(true))

    // Get device_id from Redux store first, then fallback to storage
    let deviceId = Store.getState().data.config.device_id;

    if (!deviceId) {
        // Try to get device_id from local storage
        deviceId = await STORAGE.get('deviceId');
    }

    if (!deviceId) {
        Store.dispatch(setLoading(false))
        return {
            error: "Device ID not found in configuration or storage"
        }
    }

    // Build URL with device_id parameter and query parameters (date and version)
    const endpoint = sprintf(API_DEVICE_BOOKING_LIST, [deviceId]);
    const queryParams = { v: API_VERSION };
    if (date) {
        queryParams.date = date;
    }

    let result = await Store.dispatch(apiGet(endpoint, queryParams))

    if (result.error) {
        Store.dispatch(setLoading(false))
        return errorFormatter(result)
    }

    Store.dispatch(setLoading(false))
    return {
        response: result.data
    }
}

export const apiGetDeviceMaintenance = async () => {
    Store.dispatch(setLoading(true))

    // Get device_id from Redux store first, then fallback to storage
    let deviceId = Store.getState().data.config.device_id;

    if (!deviceId) {
        // Try to get device_id from local storage
        deviceId = await STORAGE.get('deviceId');
    }

    if (!deviceId) {
        Store.dispatch(setLoading(false))
        return {
            error: "Device ID not found in configuration or storage"
        }
    }

    // Build URL with device_id parameter and version query parameter
    const endpoint = sprintf(API_DEVICE_MAINTENANCE, [deviceId]);
    let result = await Store.dispatch(apiGet(endpoint, { v: API_VERSION }))

    if (result.error) {
        Store.dispatch(setLoading(false))
        return errorFormatter(result)
    }

    Store.dispatch(setLoading(false))
    return {
        response: result.data
    }
}